import { Box, Paper, Stack, Typography } from "@mui/material";
import React from "react";
import QuickTixLogo from "../../../../../../Images/GX_Logo_Black_No_Bg.png";
import QrCode from "../../../../../../Images/qrCode1.png";
import moment from "moment";

function Ticket5({ ticket, ChangeColor, type, image, bookerName, navigator }) {
  const qrCodeData = ticket?.qrCode || "";
  const pevSelected = Number(ticket?.prevTicket) === ticket?.id ? true : false;
  return (
    <Paper
      elevation={0}
      sx={{
        height: "100%",
        display: "flex",
        border: pevSelected ? "2px solid #4A90E2" : "0px solid #e0e0e0",
        boxShadow: pevSelected
          ? "0 4px 12px rgba(74, 144, 226, 0.5)"
          : "0 2px 8px rgba(0, 0, 0, 0.1)",
        transition: "all 0.1s ease",
        "&:hover": {
          boxShadow: "0 4px 16px rgba(0, 0, 0, 0.2)",
          border: "1px solid #4A90E2",
          borderRadius: "1px",
        },
        justifyContent: "space-around",
        backgroundColor: ChangeColor || ticket?.bgColor || "#e8e8e8",
      }}
    >
      <Stack
        alignItems={"center"}
        direction={"row"}
        width={"10%"}
        sx={{ backgroundColor: "#222222" }}
        justifyContent={"center"}
      >
        <Stack
          variant="h6"
          Wrap
          component="div"
          sx={{
            fontWeight: "bold",
            fontSize: {
              xs: "1.5rem",
              sm: "2rem",
              md: "2rem",
              lg: "3rem",
            },
            color: "#ffff",
            writingMode: "vertical-rl",
            transform: "rotate(180deg)",
            fontFamily: "Bebas Neue",
            padding: 0,
            margin: 0,
          }}
          textAlign={"center"}
        >
          {type ? type : ticket?.type?.[0]?.typeName ?? "VIP"}
        </Stack>
      </Stack>

      <Stack
        direction={"column"}
        width={"65%"}
        sx={{
          borderRight: "3px dotted black",
        }}
        // "#F5F0E8"
      >
        <Stack
          flex={1}
          display={"flex"}
          direction={"row"}
          justifyContent={"space-between"}
          mt={3}
        >
          <img
            src={image ? image : QuickTixLogo}
            alt="QR"
            style={{
              width: "25%",
              maxHeight: "80px",
              maxWidth: "80%",
              height: "auto",
              objectFit: "contain",
              marginLeft: "2%",
            }}
          />

          <Typography
            variant="body2"
            sx={{
              fontSize: {
                xs: "0.65rem",
                sm: "1rem",
              },
              fontFamily: "Bebas Neue",
            }}
            mr={"1rem"}
          >
            {moment(ticket?.date).format("MM/DD/YYYY")} &nbsp;&nbsp;&nbsp;{" "}
            {ticket?.time}
          </Typography>
        </Stack>
        <Stack flex={5} direction={"row"} pb={"1rem"}>
          <Stack flex={{ lg: 3, md: 2, sm: 2, xs: 2 }} my={"auto"}>
            <Typography
              variant="h4"
              sx={{
                fontWeight: 400,
                fontSize: {
                  xs: "1rem",
                  sm: "1.2rem",
                  md: "1.4rem",
                  lg: "1.7rem",
                },
                maxWidth: "170px",
                my: "auto",
                fontFamily: "Alatsi",
              }}
              ml={2}
            >
              {ticket?.title}
            </Typography>
            <Typography ml={2} variant="h9">
              {ticket?.organizer}
            </Typography>
          </Stack>

          <Stack
            flex={1}
            direction={"column"}
            justifyContent={"flex-end"}
            pr={1.5}
          >
            <Stack alignItems={"end"}>
              <Typography
                sx={{
                  fontSize: { xs: "0.5rem", sm: "0.6rem" },
                  color: "#737373",
                  fontFamily: "Lato",
                  fontWeight: 400,
                }}
                variant="caption"
              >
                {ticket?.ticketName ? ticket?.ticketName : "Ticket"}
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: "1rem",
                  whiteSpace: "nowrap",
                  fontFamily: "Lato",
                  fontWeight: 600,
                }}
              >
                {bookerName}
              </Typography>
              ${" "}
              {ticket?.price != null && ticket?.price !== ""
                ? ticket?.ticketPrices
                  ? Object.values(ticket?.ticketPrices)[0]
                  : Number(ticket?.price) === 0
                  ? "Free"
                  : Number(ticket?.price) % 1 === 0
                  ? Number(ticket?.price).toFixed(0)
                  : ticket.price
                : "211"}
            </Stack>
          </Stack>
        </Stack>

        <Stack flex={1} direction={"row"}>
          <Stack>
            <Typography
              variant="body2"
              sx={{
                fontSize: { xs: "0.7rem", sm: "0.9rem" },
                fontFamily: "Lato",
              }}
              m={1}
            >
              {ticket?.location}
            </Typography>
          </Stack>
        </Stack>
      </Stack>

      <Box
        alignItems={"center"}
        sx={{
          display: "flex",
          flexDirection: "column",
        }}
        width={"25%"}
        justifyContent={"center"}
        position={"relative"}
        gap={"0.5rem"}
      >
        <Typography
          variant="h6"
          sx={{
            fontSize: {
              xs: "0.6rem",
              sm: "0.875rem",

              color: "#191919",
              fontFamily: "Lato",
            },
          }}
        >
          {ticket?.code}
        </Typography>
        {navigator === "ct" ? (
          <></>
        ) : !qrCodeData ? (
          <img
            src={QrCode}
            alt="qr"
            style={{
              width: "100%",
              maxWidth: "80%",
              height: "auto",
              maxHeight: "80px",
              objectFit: "contain",
            }}
          />
        ) : (
          <img
            src={ticket?.qrCode || QrCode}
            alt="QR"
            style={{
              width: "100%",
              maxWidth: "100%",
              height: "auto",
              maxHeight: "100px",
              objectFit: "contain",
            }}
          />
        )}
        <Stack ml={2} mt={1}>
          <img
            alt="Logo"
            src={QuickTixLogo}
            style={{
              width: "100%",
              maxWidth: "80%",
              height: "auto",
              maxHeight: "30px",
              objectFit: "contain",
            }}
          />
        </Stack>
      </Box>
    </Paper>
  );
}

export default Ticket5;
